import React, { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { Led } from "./Led";
import { LED_COLORS } from "../../utils/colors";
import { acrAPI } from "../../utils/api";
import { License } from "../../models/LicenseModel";
import { getFormatedUtcDate } from "../../utils/date";
import { translate } from "../../i18n";

export function ServerLed(props:any): React.ReactElement {
    
  const [serverConnexionStatus,setServerConnexionStatus] = useState<boolean|null>(false);
  const [license,setLicense] = useState<License|null>(null);
  const [serverLedColor,setServerLedColor] = useState(LED_COLORS.WAITING);
  const [tooltipMessage, setTooltipMessage] = useState("");


  useEffect(() => {
    acrAPI.getLicenseStatus();
    const licenseSub = acrAPI.licenseSubject.subscribe(updateLicense);
    const connexionStatusSubject = acrAPI.connexionStatusSubject.subscribe(updateConnexionStatus);    
    return () => {licenseSub?.unsubscribe, connexionStatusSubject?.unsubscribe}
  },[]);

  useEffect(() => {
    updateStatus();
  },[license,serverConnexionStatus]);

  const updateConnexionStatus = (status: boolean | null): void => {
    setServerConnexionStatus(status);
  }

  const updateLicense = (license: License | null): void => {
    setLicense(license);
  }

  const updateStatus = (): void => {
    if (serverConnexionStatus == null || license == null) {
      setServerLedColor(LED_COLORS.WAITING);
    } else if (!serverConnexionStatus || license?.isError()) {
      setServerLedColor(LED_COLORS.ERROR);
      setTooltipMessage(translate("license invalid", { expirationDate: license?.expirationDate }))
    } else if (license?.isWarning()) {
      setServerLedColor(LED_COLORS.WARNING)
      setTooltipMessage(`${translate("license almost expired")} (${getFormatedUtcDate(license?.expirationDate)})`)
    } else if (license?.isOk()) {
      setServerLedColor(LED_COLORS.OK);
    }
  }

  //console.log(`[${name}] render`); // TODO remove
  return (
    <Tooltip disableFocusListener title={tooltipMessage} placement="bottom">
      <span>
        <Led dataCy="server-status-led" colors={serverLedColor} />
      </span>
    </Tooltip>
  );
}
